import React from 'react'

// Fila de 5 estrellas de valoración de Google (compartida entre los bloques
// clásico y moderno de reseñas).
const Stars = () => (
  <div aria-label='5 estrellas' style={{ display: 'flex', gap: '2px', alignItems: 'center' }}>
    {[1, 2, 3, 4, 5].map((i) => (
      <svg key={i} width='18' height='18' viewBox='0 0 48 48' fill='none' aria-hidden='true'>
        <path
          d='M24 4l5.64 11.526L43.2 17.76l-9.6 9.672L36.24 42 24 34.8 11.76 42 14.4 27.432 4.8 17.76l13.56-2.234L24 4z'
          fill='#fbbc04'
          stroke='#ea8c00'
          strokeWidth='1.2'
        />
      </svg>
    ))}
  </div>
)

export default Stars
